import { IContactCenterTenant } from './types';

/**
 * Resolves a numeric-tenant-id task/task-context to the tenant-level OrgNode
 * Guid the agent-inbox MFEs key scope on. Mirrors the join AuthModule.hasAccessToTenant
 * already does over the user's tenant list — no second lookup path.
 *
 * Absent is a valid result, not an error: a tenant not in the user's list, or
 * a tenant whose orgNodeId hasn't been populated yet, must not fall back to
 * org.id (that substitution is exactly what CCPE-1137 removes).
 */
export function resolveOrgNodeId(
  tenants: ReadonlyArray<IContactCenterTenant>,
  tenantId: string | undefined,
): string | undefined {
  if (!tenantId) {
    return undefined;
  }
  return tenants.find((t) => t.id === tenantId)?.orgNodeId ?? undefined;
}

/**
 * Reverse of resolveOrgNodeId — the agent-inbox MFEs hand back an OrgNode
 * Guid (click-to-call, monolith navigation), but numeric-tenant-id call sites
 * (outbound-call GraphQL mutations, monolith tenant-redirect URLs) still need
 * the numeric id. Out of scope for CCPE-1137: those call sites aren't
 * migrating to the Guid, so this is the bridge back, not a second identifier.
 */
export function resolveTenantId(
  tenants: ReadonlyArray<IContactCenterTenant>,
  orgNodeId: string | undefined,
): string | undefined {
  if (!orgNodeId) {
    return undefined;
  }
  return tenants.find((t) => t.orgNodeId === orgNodeId)?.id ?? undefined;
}
